// Configuration des statistiques de production par province
export const productionStatsByProvince = {
  Estuaire: [
    { culture: "Manioc", production: 2850, unite: "tonnes" },
    { culture: "Banane plantain", production: 1750, unite: "tonnes" },
    { culture: "Igname", production: 980, unite: "tonnes" },
    { culture: "Taro", production: 650, unite: "tonnes" },
    { culture: "Patate douce", production: 420, unite: "tonnes" },
    { culture: "Cacao", production: 320, unite: "tonnes" },
    { culture: "Légumes verts", production: 580, unite: "tonnes" },
  ],
  "Ogooué-Lolo": [
    { culture: "Manioc", production: 1850, unite: "tonnes" },
    { culture: "Banane plantain", production: 1320, unite: "tonnes" },
    { culture: "Igname", production: 720, unite: "tonnes" },
    { culture: "Taro", production: 480, unite: "tonnes" },
    { culture: "Arachide", production: 390, unite: "tonnes" },
    { culture: "Poivron", production: 185, unite: "tonnes" },
  ],
  "Wouleu-Ntem": [
    { culture: "Manioc", production: 2250, unite: "tonnes" },
    { culture: "Banane plantain", production: 1680, unite: "tonnes" },
    { culture: "Cacao", production: 940, unite: "tonnes" },
    { culture: "Maïs", production: 780, unite: "tonnes" },
    { culture: "Igname", production: 650, unite: "tonnes" },
    { culture: "Arachide", production: 520, unite: "tonnes" },
  ],
  "Haut-Ogooué": [
    { culture: "Manioc", production: 1650, unite: "tonnes" },
    { culture: "Banane plantain", production: 1280, unite: "tonnes" },
    { culture: "Patate douce", production: 820, unite: "tonnes" },
    { culture: "Igname", production: 580, unite: "tonnes" },
    { culture: "Tomate", production: 410, unite: "tonnes" },
    { culture: "Maïs", production: 350, unite: "tonnes" },
  ],
  "Ngounié": [
    { culture: "Manioc", production: 1950, unite: "tonnes" },
    { culture: "Banane plantain", production: 1480, unite: "tonnes" },
    { culture: "Igname", production: 720, unite: "tonnes" },
    { culture: "Taro", production: 520, unite: "tonnes" },
    { culture: "Pastèque", production: 380, unite: "tonnes" },
    { culture: "Mangue", production: 290, unite: "tonnes" },
  ],
  "Ogooué-Maritime": [
    { culture: "Manioc", production: 1350, unite: "tonnes" },
    { culture: "Banane plantain", production: 980, unite: "tonnes" },
    { culture: "Taro", production: 580, unite: "tonnes" },
    { culture: "Maïs", production: 430, unite: "tonnes" },
    { culture: "Pastèque", production: 270, unite: "tonnes" },
    { culture: "Légumes verts", production: 320, unite: "tonnes" },
  ],
  "Moyen-Ogooué": [
    { culture: "Manioc", production: 1760, unite: "tonnes" },
    { culture: "Banane plantain", production: 1240, unite: "tonnes" },
    { culture: "Igname", production: 680, unite: "tonnes" },
    { culture: "Taro", production: 450, unite: "tonnes" },
    { culture: "Patate douce", production: 380, unite: "tonnes" },
    { culture: "Arachide", production: 290, unite: "tonnes" },
  ],
  "Nyanga": [
    { culture: "Manioc", production: 1580, unite: "tonnes" },
    { culture: "Banane plantain", production: 1150, unite: "tonnes" },
    { culture: "Taro", production: 710, unite: "tonnes" },
    { culture: "Igname", production: 520, unite: "tonnes" },
    { culture: "Patate douce", production: 380, unite: "tonnes" },
    { culture: "Légumes verts", production: 260, unite: "tonnes" },
  ],
  "Ogooué-Ivindo": [
    { culture: "Manioc", production: 1480, unite: "tonnes" },
    { culture: "Banane plantain", production: 1080, unite: "tonnes" },
    { culture: "Igname", production: 620, unite: "tonnes" },
    { culture: "Taro", production: 450, unite: "tonnes" },
    { culture: "Cacao", production: 380, unite: "tonnes" },
    { culture: "Café", production: 250, unite: "tonnes" },
  ],
};

// Garder la correspondance des provinces pour la carte
export const provinceMapping = {
  GA1: "Estuaire",
  GA2: "Haut-Ogooué",
  GA3: "Moyen-Ogooué",
  GA4: "Ngounié",
  GA5: "Nyanga",
  GA6: "Ogooué-Ivindo",
  GA7: "Ogooué-Lolo",
  GA8: "Ogooué-Maritime",
  GA9: "Wouleu-Ntem",
};